import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, resolveComponent as _resolveComponent, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createBlock as _createBlock, normalizeClass as _normalizeClass, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "onboarding-overlay"
}
const _hoisted_2 = { class: "daily-sync-submission__header" }
const _hoisted_3 = /*#__PURE__*/_createTextVNode("My daily sync⚡ ")
const _hoisted_4 = { class: "daily-sync-submission__chips" }
const _hoisted_5 = { class: "daily-sync-submission__main" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("h6", null, "Completed previously", -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("h6", null, "What are you working on today?", -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("h6", null, "Team talk", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DailySyncOnboarding = _resolveComponent("DailySyncOnboarding")!
  const _component_AppIcon = _resolveComponent("AppIcon")!
  const _component_DailySyncMoodSelector = _resolveComponent("DailySyncMoodSelector")!
  const _component_DailySyncAvailabilitySelector = _resolveComponent("DailySyncAvailabilitySelector")!
  const _component_DailySyncTaskList = _resolveComponent("DailySyncTaskList")!
  const _component_AppTextEditor = _resolveComponent("AppTextEditor")!
  const _directive_tooltip = _resolveDirective("tooltip")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_Transition, { name: "fade" }, {
      default: _withCtx(() => [
        (_ctx.showOnboarding)
          ? (_openBlock(), _createElementBlock("div", _hoisted_1))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    _createElementVNode("section", {
      class: _normalizeClass(["daily-sync-submission", { 'lifted': _ctx.showOnboarding }])
    }, [
      _createVNode(_component_DailySyncOnboarding, {
        modelValue: _ctx.showOnboarding,
        "onUpdate:modelValue": [
          _cache[0] || (_cache[0] = ($event: any) => ((_ctx.showOnboarding) = $event)),
          _cache[1] || (_cache[1] = ($event: any) => (_ctx.hideOnboarding()))
        ]
      }, null, 8, ["modelValue"]),
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("h5", null, [
          _hoisted_3,
          _withDirectives(_createVNode(_component_AppIcon, {
            onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.showOnboarding = true)),
            name: "info",
            size: "18"
          }, null, 512), [
            [_directive_tooltip, { distance: '8', content: 'Feature tour' }]
          ])
        ]),
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_DailySyncMoodSelector, {
            disabled: _ctx.isSaving,
            modelValue: _ctx.mood,
            "onUpdate:modelValue": [
              _cache[3] || (_cache[3] = ($event: any) => ((_ctx.mood) = $event)),
              _cache[4] || (_cache[4] = ($event: any) => (_ctx.saveDailySync()))
            ]
          }, null, 8, ["disabled", "modelValue"]),
          _createVNode(_component_DailySyncAvailabilitySelector, {
            modelValue: _ctx.userSchedule,
            "onUpdate:modelValue": [
              _cache[5] || (_cache[5] = ($event: any) => ((_ctx.userSchedule) = $event)),
              _cache[6] || (_cache[6] = ($event: any) => (_ctx.saveDailySync()))
            ]
          }, null, 8, ["modelValue"])
        ])
      ]),
      _createElementVNode("div", _hoisted_5, [
        (_ctx.completedTasks?.length)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              _hoisted_6,
              _createElementVNode("div", {
                class: _normalizeClass(["daily-sync-submission__main__completed", { 'expanded': _ctx.expandCompletedTaskList }])
              }, [
                (_ctx.completedTasks.length > 1)
                  ? (_openBlock(), _createElementBlock("div", {
                      key: 0,
                      onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.expandCompletedTaskList = !_ctx.expandCompletedTaskList)),
                      class: "daily-sync-submission__main__completed__header"
                    }, [
                      _createElementVNode("p", null, _toDisplayString(_ctx.completedTasks.length) + " completed tasks", 1),
                      _createVNode(_component_AppIcon, {
                        name: "arrow",
                        size: "12"
                      })
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.expandCompletedTaskList || _ctx.completedTasks.length === 1)
                  ? (_openBlock(), _createBlock(_component_DailySyncTaskList, {
                      key: 1,
                      modelValue: _ctx.completedTasks,
                      "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.completedTasks) = $event)),
                      editable: false
                    }, null, 8, ["modelValue"]))
                  : _createCommentVNode("", true)
              ], 2)
            ], 64))
          : _createCommentVNode("", true),
        _hoisted_7,
        _createVNode(_component_DailySyncTaskList, {
          modelValue: _ctx.openTasks,
          "onUpdate:modelValue": [
            _cache[9] || (_cache[9] = ($event: any) => ((_ctx.openTasks) = $event)),
            _cache[10] || (_cache[10] = ($event: any) => (_ctx.saveDailySync()))
          ],
          group: "my-tasks",
          onDelete: _ctx.onDeleteTask,
          class: _normalizeClass({ 'daily-sync-list-saving': _ctx.isSaving })
        }, null, 8, ["modelValue", "onDelete", "class"]),
        _hoisted_8,
        _createVNode(_component_AppTextEditor, {
          modelValue: _ctx.message,
          "onUpdate:modelValue": [
            _cache[11] || (_cache[11] = ($event: any) => ((_ctx.message) = $event)),
            _cache[15] || (_cache[15] = ($event: any) => (_ctx.onTeamTalkUpdated()))
          ],
          placeholder: "Anything else you'd like to share with your team?",
          editable: true,
          disabled: _ctx.isSaving,
          borderless: false,
          onProcessingImage: _cache[12] || (_cache[12] = ($event: any) => (_ctx.isImageProcessing = true)),
          onProcessingImageCompleted: _cache[13] || (_cache[13] = ($event: any) => (_ctx.isImageProcessing = false)),
          onBlur: _cache[14] || (_cache[14] = ($event: any) => (_ctx.saveChangesToTeamTalk()))
        }, null, 8, ["modelValue", "disabled"])
      ])
    ], 2)
  ]))
}